(() => {
  if (window.lvCicaBoot) { window.lvCicaBoot(document); return; }
  const parse = node => { try { return JSON.parse(node?.textContent || '{}'); } catch { return {}; } };
  const boot = scope => {
    scope.querySelectorAll('[data-lv-hero]:not([data-lv-ready])').forEach(root => {
      root.dataset.lvReady = 'true';
      const image = root.querySelector('[data-lv-hero-image]');
      const thumbs = [...root.querySelectorAll('[data-lv-image]')];
      const dialog = root.querySelector('[data-lv-dialog]');
      const selectImage = (url, alt, caption, index) => {
        image.src = url; image.alt = alt;
        root.querySelector('[data-lv-caption]').textContent = caption;
        root.querySelector('[data-lv-image-count]').textContent = `${String(index + 1).padStart(2, '0')} / ${String(thumbs.length).padStart(2, '0')}`;
        root.querySelector('.gallery-stage').classList.toggle('is-individual', index > 0);
        thumbs.forEach((button, n) => button.setAttribute('aria-pressed', String(n === index)));
      };
      thumbs.forEach((button, index) => button.addEventListener('click', () => selectImage(button.dataset.lvImage, button.dataset.alt, button.dataset.caption, index)));
      root.querySelector('[data-lv-image-count]').textContent = `01 / ${String(thumbs.length).padStart(2, '0')}`;
      const zoom = () => { dialog.querySelector('img').src = image.src; dialog.querySelector('img').alt = image.alt; dialog.showModal(); };
      root.querySelector('.zoom-trigger').addEventListener('click', zoom);
      root.querySelector('.zoom-sign')?.addEventListener('click', zoom);
      dialog.querySelector('.dialog-close').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', e => { if (e.target === dialog) dialog.close(); });
      const form = root.querySelector('product-form form');
      const input = form.querySelector('[name="quantity"]');
      const minus = root.querySelector('[data-lv-minus]');
      const plus = root.querySelector('[data-lv-plus]');
      const normalize = () => {
        const min = Number(input.min) || 1, step = Number(input.step) || 1;
        const max = input.max ? Math.max(min, Number(input.max)) : Infinity;
        const n = Number(input.value) || min;
        input.value = Math.min(max, Math.max(min, min + Math.round((n - min) / step) * step));
        minus.disabled = Number(input.value) <= min;
        plus.disabled = Number(input.value) + step > max;
      };
      minus.addEventListener('click', () => { input.value = Number(input.value) - (Number(input.step) || 1); normalize(); input.dispatchEvent(new Event('change', {bubbles:true})); });
      plus.addEventListener('click', () => { input.value = Number(input.value) + (Number(input.step) || 1); normalize(); input.dispatchEvent(new Event('change', {bubbles:true})); });
      input.addEventListener('change', normalize);
      normalize();
      const add = root.querySelector('[data-lv-add]');
      const sticky = root.querySelector('.sticky-purchase');
      const bindPreviewBar = () => {
        const bar = document.querySelector('#PBarNextFrameWrapper');
        if (!bar) return false;
        const position = () => {
          const rect = bar.getBoundingClientRect();
          sticky.style.bottom = `${rect.height && rect.top < innerHeight && rect.bottom > 0 ? Math.max(0, innerHeight - rect.top) : 0}px`;
        };
        new ResizeObserver(position).observe(bar);
        new MutationObserver(position).observe(bar, {attributes:true});
        window.addEventListener('resize', position, {passive:true});
        position();
        return true;
      };
      if (!bindPreviewBar()) {
        const barWatcher = new MutationObserver(() => { if (bindPreviewBar()) barWatcher.disconnect(); });
        barWatcher.observe(document.body, {childList:true});
      }
      const stickyAdd = root.querySelector('[data-lv-sticky-add]');
      stickyAdd.addEventListener('click', () => {
        if (!add.disabled && add.getAttribute('aria-disabled') !== 'true') add.click();
      });
      const observer = new IntersectionObserver(entries => {
        const entry = entries[0];
        sticky.classList.toggle('visible', !entry.isIntersecting && entry.boundingClientRect.bottom < 0);
      });
      observer.observe(root.querySelector('[data-lv-purchase]'));
      root._lvObserver = observer;
      new MutationObserver(() => {
        stickyAdd.disabled = add.disabled || add.getAttribute('aria-disabled') === 'true';
        const error = root.querySelector('.product-form__error-message-wrapper');
        if (error && !error.hidden && error.textContent.trim()) error.scrollIntoView({behavior:'smooth', block:'center'});
      }).observe(root.querySelector('product-form'), {attributes:true, subtree:true, attributeFilter:['hidden','disabled','aria-disabled']});
      const variants = parse(root.querySelector('[data-lv-variants]'));
      const labels = parse(root.querySelector('[data-lv-labels]'));
      root.querySelector('[data-lv-variant]')?.addEventListener('change', event => {
        const variant = variants.find(v => String(v.id) === event.target.value);
        if (!variant) return;
        form.querySelector('[name="id"]').value = variant.id;
        root.querySelectorAll('[data-lv-price]').forEach(p => p.innerHTML = variant.price);
        add.disabled = stickyAdd.disabled = !variant.available;
        add.removeAttribute('aria-disabled');
        root.querySelector('[data-lv-submit]').textContent = variant.available ? labels.add : labels.sold;
        root.querySelector('[data-lv-sticky-text]').textContent = variant.available ? labels.sticky : labels.sold;
        input.min = variant.min || 1; input.step = variant.step || 1;
        if (variant.max == null) input.removeAttribute('max'); else input.max = variant.max;
        normalize();
        if (variant.image) image.src = variant.image;
        const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
      });
    });
    scope.querySelectorAll('[data-lv-routine]:not([data-lv-ready])').forEach(root => {
      root.dataset.lvReady = 'true';
      const data = parse(root.querySelector('[data-lv-routine-data]'));
      root.querySelectorAll('[data-routine]').forEach(button => button.addEventListener('click', () => {
        const content = data[button.dataset.routine];
        if (!content) return;
        root.querySelectorAll('[data-routine]').forEach(b => { b.classList.toggle('selected', b === button); b.setAttribute('aria-pressed', String(b === button)); });
        root.querySelectorAll('[data-routine-field]').forEach(el => {
          const key = el.dataset.routineField;
          if (key === 'description') el.innerHTML = content[key]; else el.textContent = content[key];
        });
      }));
    });
  };
  window.lvCicaBoot = boot;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document));
  else boot(document);
  document.addEventListener('shopify:section:load', event => boot(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelector('[data-lv-hero]')?._lvObserver?.disconnect());
  document.addEventListener('shopify:block:select', event => { if (event.target.tagName === 'DETAILS') event.target.open = true; });
})();
